// extracted by mini-css-extract-plugin
module.exports = {"root":"NamesEditor_root__13vDb","dirtyDot":"NamesEditor_dirtyDot__1M-Wf","name":"NamesEditor_name__2ByAV","editButton":"NamesEditor_editButton__2SOau"};